import { render, staticRenderFns } from "./DeliveryPayment.vue?vue&type=template&id=f94af64a"
import script from "./DeliveryPayment.vue?vue&type=script&lang=js"
export * from "./DeliveryPayment.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPayment.vue?vue&type=style&index=0&id=f94af64a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports